import "./wizzard.scss";
import { useState, useEffect } from "react";

import { IStep } from "../../../analytics/pages/model-configuration-new/model-configuration-new";

export interface IProps {
  data?: IStep[];
  children?: React.ReactNode;
  getSelectedTab: (tab: number, id?: string) => void;
  selectedTabFromParent? : number;
  allowedTabs?: number[];
  noNumeration?: boolean;
  isFullscreen?: boolean;
  hideDisabledTabs?: boolean;
}

const Wizzard = ({ data, hideDisabledTabs, children, isFullscreen, noNumeration, allowedTabs, selectedTabFromParent, getSelectedTab }: IProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(1);
  useEffect(() => {
    selectedTabFromParent && setSelectedTab(selectedTabFromParent);
  }, [selectedTabFromParent]);

  const renderTabs = () =>{
    const result:JSX.Element[] = [];
    data?.forEach((tab, i) => {
      if (allowedTabs?.indexOf(tab.index) === -1 && hideDisabledTabs) {
        return;
      }
      result.push(
        <div
          role="tab"
          className={`${selectedTab === tab.index ? "wizzard-tab-selected" : ""} wizzard-tab ${allowedTabs?.indexOf(tab.index) === -1? "wizzard-disabled-tab" : ""}`}
          key={i}
          onClick={() => {
            if (allowedTabs?.indexOf(tab.index) !== -1) {
              setSelectedTab(tab.index); 
              getSelectedTab(tab.index, tab?.id);
            }          
          }}
        >
          {noNumeration? "" : `${i+1}.`} {tab.stepName}
        </div>
      );
    });
    return result;
  };

  return (
    <div className={`wizzard ${isFullscreen ? "full" : ""}`}>
      <div className="wizzard-tabs">
        {renderTabs()}
      </div>
      <div className="wizzard-child">
        {children}
      </div>
    </div>
  );
};

export default Wizzard;
